export default __webpack_public_path__ + "static/awards-title-logo-bg-3e887958cdfdc2b0ad4bdbafa9a848c6.svg";